import React from "react";

import "./EmptyData.css";

/**
 *  Types:
        documents
        connection
        done
        error
        images
        inbox
        messages
        search
        tasks
 */

export const EmptyData = ({ title, type }) => {
  return (
    <div className="EmptyData">
      <div className={`EmptyData_img ${type ? type : 'documents'}`}></div>
      {title && <p className="EmptyData_title">{title}</p>}
    </div>
  );
};
